export default { 
  h32d17893ef9d0c4cd54821b148a29bad: [[({}, [C0, C1]) => [C0(), C1()], {}]] 
}